// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__mwIRf","row":"Node_row__YD2BL","label":"Node_label__1tqk7","footer":"Node_footer__3osnl"};